const TEST_ID_PREFIX = 'Visualizer';

export const testId = (text: string) => `${TEST_ID_PREFIX}_${text}`;
